import { BigNumber } from 'ethers';
import {
    IClosePositionMessage,
    IOpenPositionMessage,
    IUpdatePositionMessage
} from '../services/api/api.interfaces';
import { contractAddresses } from './config/contracts.config';


export class SignatureHelper {

    ddpDomain = {
        name: 'NereusDDPPermit',
        version: '1',
        chainId: 137,
        verifyingContract: contractAddresses.polygon.ddp,
    };

    getDeadlineIn7Days() {
        return Math.trunc(Date.now() / 1000) + 60 * 60 * 24 * 7;
    }

    async signClosePositionMessage(signTypedData: any, message: IClosePositionMessage) {
        const types = {
            PermitPositionClose: [
                { name: "user", type: "address" },
                { name: "positionId", type: "uint256" },
                { name: "nonce", type: "uint256" },
                { name: "deadline", type: "uint256" },
            ]
        };
        const typedData = {
            types,
            primaryType: 'PermitPositionClose',
            domain: this.ddpDomain,
            message,
        };
        return signTypedData(typedData);
    }
    async signUpdatePositionMessage(signTypedData: any, message: IUpdatePositionMessage) {
        const types = {
            PermitPositionUpdate: [
                { name: "user", type: "address" },
                { name: "positionId", type: "uint256" },
                { name: "tp", type: "uint256" },
                { name: "sl", type: "uint256" },
                { name: "nonce", type: "uint256" },
                { name: "deadline", type: "uint256" },
            ]
        };

        const typedData = {
            types,
            primaryType: 'PermitPositionUpdate',
            domain: this.ddpDomain,
            message,
        };
        return await signTypedData(typedData);
    }


    async signOpenPositionMessage(signTypedData: any, message: IOpenPositionMessage) {
        const types = {
            PermitPositionOpen: [
                { name: 'user', type: 'address' },
                { name: 'symbol', type: 'string' },
                { name: 'token', type: 'address' },
                { name: 'amount', type: 'uint256' },
                { name: 'leverage', type: 'uint8' },
                { name: 'nonce', type: 'uint256' },
                { name: 'deadline', type: 'uint256' }
            ]
        };

        const typedData = {
            types,
            primaryType: 'PermitPositionOpen',
            domain: this.ddpDomain,
            message,
        };

        return await signTypedData(typedData);
    }

    async signWithdrawMessage(signTypedData: any, userAddress: string, amount: BigNumber, deadline: number, nonce: number) {
        const withdrawMessage = {
            user: userAddress,
            token: contractAddresses.polygon.usdt,
            amount: amount.toString(),
            nonce,
            deadline
        };

        const typedData = {
            types: {
                PermitWithdraw: [
                    { name: 'user', type: 'address' },
                    { name: 'token', type: 'address' },
                    { name: 'amount', type: 'uint256' },
                    { name: 'nonce', type: 'uint256' },
                    { name: 'deadline', type: 'uint256' },
                ],
            },
            primaryType: 'PermitWithdraw',
            domain: this.ddpDomain,
            message: withdrawMessage,
        };

        return await signTypedData(typedData);
    }
}

export const signatureHelper = new SignatureHelper();